import axios from 'axios'
import i18n from '../../i18n'

const state = () => ({
    establishment: null,
    websiteSetting: null,
    appSetting: null,
    paymentMethods: [],
    invoiceSequences: [],
    establishmentCancelRate: [],
    establishmentModificationPolicy: null,
    paymentMethodsSelectedIds: [],
})

const mutations = {
    SET_ESTABLISHMENT(state, payload) {
        state.establishment = payload
    },

    UPDATE_ESTABLISHMENT(state, updatedData) {
        state.establishment = {
            ...state.establishment,
            ...updatedData,
        }
    },

    SET_WEBSITE_SETTING(state, payload) {
        state.websiteSetting = payload
    },

    SET_APP_SETTING(state, payload) {
        state.appSetting = payload
    },

    ADD_APP_SETTING(state, payload) {
        if (!Array.isArray(payload)) return

        payload.forEach(({ key, value, is_required }) => {
            const existing = state.appSetting.find((item) => item.key === key)

            if (existing) {
                existing.value = value
                existing.is_required = is_required
            } else {
                state.appSetting.push({ key, value, is_required })
            }
        })
    },

    SET_PAYMENT_METHODS(state, payload) {
        state.paymentMethods = payload
    },

    SET_PAYMENT_METHODS_SELECTED_IDS(state, payload) {
        state.paymentMethodsSelectedIds = payload
    },

    SET_ESTABLISHMENT_CANCEL_RATE(state, payload) {
        state.establishmentCancelRate = payload
    },

    SET_ESTABLISHMENT_MODIFICATION_POLICY(state, payload) {
        state.establishmentModificationPolicy = payload
    },

    SET_INVOICE_SEQUENCES(state, payload) {
        state.invoiceSequences = payload
    },
}

const actions = {
    async updateEstablishment({ commit }, payload) {
        const data = await axios
            .put(`/back-office/v2/establishment/${payload.establishment.id}/update`, payload)
            .then((res) => res.data)

        if (data.data) {
            if (data.data.establishment) commit('SET_ESTABLISHMENT', data.data.establishment)
            if (data.data.websiteSetting) commit('SET_WEBSITE_SETTING', data.data.websiteSetting)
            if (data.data.appSetting) commit('SET_APP_SETTING', data.data.appSetting)
        }

        // Sync frontend locale when establishment language changes
        if (payload.establishment?.language) {
            const newLocale = payload.establishment.language
            const supported = ['fr', 'en']
            if (supported.includes(newLocale)) {
                window.appLocale = newLocale
                localStorage.setItem('locale', newLocale)
                if (i18n.locale !== newLocale) {
                    i18n.locale = newLocale
                }
            }
        }

        return data
    },
}

const getters = {
    appSetting: (state) => state.appSetting,
    establishment: (state) => state.establishment,
    websiteSetting: (state) => state.websiteSetting,
    paymentMethods: (state) => state.paymentMethods,
    invoiceSequences: (state) => state.invoiceSequences,
    establishmentCancelRate: (state) => state.establishmentCancelRate,
    establishmentModificationPolicy: (state) => state.establishmentModificationPolicy,
    paymentMethodsSelectedIds: (state) => state.paymentMethodsSelectedIds,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
